<div class="head row">
  @if (tableContext.canSelect()) {
    <div
      class="col table-head"
      style="width: 40px; min-width: 40px; max-width: 40px; text-align: center"
    >
      <ng-content></ng-content>
    </div>
  }
  @if (tableContext.hasIndexCol()) {
    <div
      class="col table-head"
      style="width: 80px; min-width: 80px; max-width: 80px; text-align: center"
    >
      <div class="head-name">#</div>
    </div>
  }
  @for (
    head of tableContext.tableData().heads;
    let i = $index;
    track head.name
  ) {
    @if (!head.ignore) {
      <div
        class="col table-head"
        [title]="head.name"
        [ngClass]="{
          active:
            head.name === tableContext.headName() && head.dataType !== 'link',
        }"
      >
        @if (head.dataType !== 'link') {
        <div (click)="tableContext.sortTable(head.name)">
          <div class="heading">
            <p
              class="head-name"
              [ngClass]="{ 'text-center': head.type === 'button' }"
            >
              {{ head.name }}
            </p>
            @if (
              tableContext.headName() === head.name && head.type !== 'group'
            ) {
              <button class="sort-button">
                @if (head.asc === false) {
                  <ng-icon
                    name="NavArrowUp"
                    color="#2E91D3"
                    size="24"
                  ></ng-icon>
                } @else {
                  <ng-icon
                    name="NavArrowDown"
                    color=" #2E91D3"
                    size="24"
                  ></ng-icon>
                }
              </button>
            }
          </div>
          @if (head.type === 'group') {
            <div class="subHeads">
              @for (subCol of head.groupColumns; track subCol.name) {
                <small class="subHead">
                  {{ subCol.name }}
                </small>
              }
            </div>
          }
        </div>
        } @else {
        <div class="heading">
          <p class="head-name">
            {{ head.name }}
          </p>
        </div>
        }
      </div>
    }
  }
  @for (col of tableContext.actionCol(); track col.headerName) {
    <div
      class="col table-head"
      [title]="col.headerName"
      [ngClass]="{
        active: col.headerName === tableContext.headName(),
      }"
    >
      <div>
        <div class="heading">
          <p class="head-name" [ngClass]="{ 'text-center': true }">
            {{ col.headerName }}
          </p>
        </div>
      </div>
    </div>
  }
</div>
